import { defineAction } from '~/prix'
import { z } from 'zod'
import animalProductionUpdateAction from './animalProductionUpdate.action.json' with { type: 'json' }
import { animalProductionUpsertInputObject } from '../animalProductionObject'

const animalProductionUpdateDefinition = defineAction({
  ...animalProductionUpdateAction,
  input: animalProductionUpsertInputObject.extend({
    id: z.string().uuid(),
  }),
  output: z.object({}),
})

export default animalProductionUpdateDefinition
